export const BRAND_NAME = "Because.FM";
export const BRAND_TAGLINE = "Как всё дошло до этого";
export const BRAND_DESCRIPTION = "Истории о людях, открытиях, заблуждениях и случайностях, которые меняли мир.";

